import { Link } from "react-router-dom";
import * as React from "react";
import { useQuery } from "@apollo/client";
import { Button, Card, CardContent, Chip, Grid } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import {
  UserProfile as Query,
  UserProfileVariables as Vars,
  UserProfile_userProfile as UserProfileType,
  UserProfile_userProfile_addresses as Address,
} from "types/gql-types";
import { Viewer } from "components/auth/types";
import { ContainerCard } from "components/haven-design/card/index";
import { userProfileQuery as query } from "../../../queries";
import AddressItemActions from "./popup";
import { ProfileAddressesAddModal } from "./add-edit";

type Props = {
  viewer: Viewer
};

const AddressCard:React.FC<{
  userProfile:UserProfileType,
  address:Address
}> = ({ userProfile, address }) => (
  <Grid size={{ xs: 12 }}>
    <Card variant="outlined">
      <CardContent>
        <Grid container alignItems="center">
          <Grid size={{ xs: 11 }}>
            {userProfile?.mailingAddress?.id === address.id &&
              <Chip style={{ marginRight: 4 }} size="small" color="primary" variant="outlined" label="Mailing Address" />}
            {userProfile?.currentAddress?.id === address.id &&
              <Chip size="small" color="primary" variant="outlined" label="Current Address" />}
            <div>{address.address1}</div>
            {address.address2 && <div>{address.address2}</div>}
            <div>{`${address.city}, ${address.state} ${address.zip}`}</div>
          </Grid>
          <Grid container size={{ xs: 1 }} justifyContent="flex-end">
            <Grid>
              <AddressItemActions
                userProfile={userProfile} address={address} />
            </Grid>
          </Grid>
          <hr/>
        </Grid>
      </CardContent>
    </Card></Grid>
);

const ProfileAddressesPage:React.FC<Props> = ({ viewer }) => {
  const { id } = viewer;
  const { data, loading, error } = useQuery<Query, Vars>(query, { variables: { id } });
  const [isAddOpen, setIsAddOpen] = React.useState(false);
  // loading, error
  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error.message}</div>;
  if (!data || !data.userProfile) return <div>Profile failed to load.</div>;

  return (
    <ContainerCard>
      <Grid container spacing={2}>
        <Grid container size={{ xs: 12 }}>
          <Grid><Link to="../"><ChevronLeft/></Link></Grid>
          <Grid><h1> Addresses</h1></Grid>
        </Grid>
        <Grid container justifyContent="flex-end" size={{ xs: 12 }}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Button
              fullWidth
              size="large"
              color="primary"
              variant="contained"
              onClick={() => setIsAddOpen(true)}
            >
        Add Address
            </Button>
          </Grid>
        </Grid>
        {data.userProfile.addresses.map(address => (
          // @ts-ignore
          <AddressCard key={address.id} userProfile={data.userProfile} address={address} />
        ))}
      </Grid>
      <ProfileAddressesAddModal
        isOpen={isAddOpen}
        setIsOpen={setIsAddOpen} />

    </ContainerCard>
  );
};

export default ProfileAddressesPage;
